import { Box, useTheme } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useState } from "react";
import { ReactComponent as CustomDropDownIcon } from "../../../../assets/icons/black_down_arrow.svg"; // Custom SVG icon

interface DateAndTimeProps {
  selectedDate: Date | null;
  handleDateSelect: (date: Date) => void;
}

const CalenderPickerNew: React.FC<DateAndTimeProps> = ({
  selectedDate,
  handleDateSelect,
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "white",
            padding: "0px 0px",
            borderBottom: `1px solid black`,
            width: "fit-content",
            maxWidth: "250px",
            cursor: "pointer",
          }}
          onClick={() => setOpen(true)}
        >
          <DatePicker
            value={selectedDate ? new Date(selectedDate) : null}
            onChange={(newValue: Date | null) => {
              if (newValue) {
                handleDateSelect(newValue);
                setOpen(false);
              }
            }}
            format="eee, MMM dd"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            slotProps={{
              textField: {
                variant: "standard",
                InputProps: {
                  readOnly: true,
                  endAdornment: (
                    <Box
                      sx={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpen(true);
                      }}
                    >
                      <CustomDropDownIcon />
                    </Box>
                  ),
                  disableUnderline: true,
                },
              },
            }}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default CalenderPickerNew;
